import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faX } from '@fortawesome/free-solid-svg-icons';

const CircledIcon = ({ value, className }) => {

  const iconClass = () => {
    const classNames =
      'rounded-circle small-circle align-items-center justify-content-center d-flex';
    if (value) {
      return `${classNames} bg-info`;
    }
    return `${classNames} bg-danger`;
  };

  return (
    <div className={`${iconClass()} ${className}`}>
      <FontAwesomeIcon
        color="white"
        size="1x"
        icon={value ? faCheck : faX}
      />
    </div>
  );
};

export default CircledIcon;
